<template>
	<div class="mian-msg">
		<titles name='常见问题'></titles>
		<div class="black-msg">
			<div class="item" v-for="item in list" :key="item.id">{{item.msg}}</div>
		</div>
	</div>
</template>

<script>
	import titles from '../../components/title/title.vue'
	export default {
		components: {
			titles
		},
		data() {
			return {
				list: [{
					msg: '我国去年丙肝发病人数约15万 年增长15%',
					id: 0,
					url: ''
				}, {
					msg: '中医药国际化需要遵循六个原则',
					id: 1,
					url: ''
				}, {
					msg: '药品监督行政处罚程序',
					id: 2,
					url: ''
				}]
			}
		},
		methods: {},
		mounted() {
			scroll(0, 0)
		}
	}
</script>

<style scoped lang="less">
	.item {
		font-size: 20px;
		font-family: Source Han Sans CN, Source Han Sans CN-Normal;
		font-weight: Normal;
		text-align: justifyLeft;
		color: #333333;
		margin-left: 20px;
		position: relative;
		cursor: pointer;
	}

	.item+.item {
		margin-top: 50px;
	}

	.item:hover {
		color: rgba(35, 131, 196, 1);
	}

	.item::before {
		content: '';
		display: block;
		width: 6px;
		height: 6px;
		background-color: rgba(35, 131, 196, 1);
		border-radius: 1000%;
		position: absolute;
		left: -20px;
		top: 50%;
		transform: translateY(-50%);
	}
</style>
